<template>
  <v-dialog
      v-model="menu" width="600px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn plain style="text-transform: none;"
          color="teal darken-4"
          dark
          v-bind="attrs"
          v-on="on"
        >
          Đăng nhập với app
        </v-btn>
      </template>

      <v-card flat class="rounded-xl">
        <v-card-title class="text-subtitle-1" style="word-break:break-word;text-transform: uppercase;">
          Hãy quét mã với chức năng trên app
          <v-spacer></v-spacer>
          <v-btn small color="red" @click="startLogin()" icon><v-icon>mdi-refresh</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="text-center">
          {{ loginId }}
          <qrcode-vue v-if="loginId" :value="loginId" :size="256" level="H"></qrcode-vue>
        </v-card-text>
        <v-card-actions>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
// Use standard imports (cleaner than require)
const { AuthServiceClient } = require('@/generated/auth_grpc_web_pb');
const { LoginRequest, StatusRequest } = require('@/generated/auth_pb');
const client = new AuthServiceClient(process.env.VUE_APP_BASE_URL, null, { format: 'text' });

import QrcodeVue from 'qrcode.vue'
import router from "@/router/index";

export default {
  name: "QrLogin",
  components: {
    QrcodeVue,
  },
  watch: {
    menu(value) {
      console.log(value)
      if(value)
        this.startLogin()
      else{
        this.cancelLogin();
      }
    }
  },
  data() {
    return {
      loginId: null,
      token: null,
      user: null,
      validTo:null,
      webAllowed : null,

      stream: null,
      error: null,
      menu: false
    }
  },
  methods: {
    startLogin() {
      // if (!this.username) return;
      this.error = null;
      const req = new LoginRequest();
      // req.setUsername(this.username);

      client.initiateLogin(req, {}, (err, response) => {
        if (err) {
          this.error = "Server unreachable. Please check connection.";
          return;
        }
        this.loginId = response.getLoginId();
        this.startWatching();
      });
    },

    startWatching() {
      const req = new StatusRequest();
      req.setLoginId(this.loginId);
      this.stream = client.watchLoginStatus(req, {});
      
      this.stream.on('data', (response) => {
        const status = response.getStatus();
        if (status === 'Approved') {
          this.token = response.getToken();
          this.user = response.getUser();
          this.validTo = response.getValidto();
          this.webAllowed = response.getWeballowed();
          this.loginSuccess(this.token, this.user, this.validTo, this.webAllowed)
          this.stream.cancel(); 
          // setTimeout(() => this.$router.push('/dashboard'), 2000);
        } else if (status === 'Rejected') {
          this.error = "Request denied by device.";
          this.cancelLogin();
        }
      })

      this.stream.on('error', (err) => {
        if (!this.token) {
            this.error = "Connection lost.";
        }
      });
    },
    cancelLogin() {
      if (this.stream) {
        this.stream.cancel();
        this.stream = null;
      }
      if (!this.token) this.loginId = null;
    },
    loginSuccess(tokenStr, userStr, validTo, webAllowed) {
    
      var vm = this;
      console.log(userStr.array)
          var userObj = {
            userCode: userStr.array[0],
            userName: userStr.array[1],
            email: userStr.array[2],
            employeeName: userStr.array[4],
            employeeCode: userStr.array[5],
            avatar: userStr.array[6],
          }
          localStorage.setItem('user', JSON.stringify(userObj));
          localStorage.setItem('token', tokenStr);
          localStorage.setItem('userClaim', userStr.array[7] );
          localStorage.setItem('validTo', validTo);
          localStorage.setItem('WebAllowed', webAllowed);

          let redirect = vm.$route.query.redirect
          let route = vm.$route.query.route
          let id = vm.$route.query.id
          let id2 = vm.$route.query.id2

          console.log("DEBUG:",redirect==true)
          if(redirect ==true){
            router.push({ name: route, params:{
              id: id,
              id2: id2,
            }})
          }else {
              router.push({ name: 'Home'})
          }
    }
  },

  mounted() {
  },

  beforeDestroy() {
    this.cancelLogin()
  }
}
</script>